import React, { useState, useEffect } from "react";
import { FixedSizeList as List } from "react-window";
import Styles from "../../../scss/orderHistory.module.scss";
import NoSearchResult from "../NoSearchResult";
import { IProcessedOrders } from "../constants";
import { OrderListItem } from "./OrderListItem";
import IColumn from "../../../yoello-lib/modules/components/lists/interfaces/IColumn";
import { IEmptyMessages } from "./OrderList";
import { OrderStatus } from "../../../interfaces/EOrderStatus";
interface IOrderListViewProps {
    orderList: IProcessedOrders[];
    openOrderDialog: (item: IProcessedOrders) => void;
    columns: IColumn<string>[];
    emptyMessageObject?: IEmptyMessages;
    heightOverride?: number;
    orderListType?:string;
}
interface IListItemRow {
    index: number,
    style: Object;
}


//pass through the list component
export function OrderListView({
    orderList,
    openOrderDialog,
    columns,
    emptyMessageObject,
    heightOverride,
    orderListType
}: IOrderListViewProps) {
    const [windowHeight] = useState(calculateListHeight());
    const [filteredOrders, setFilteredOrders] = useState<IProcessedOrders[] | []>([]);
    const showCheckBox = orderListType === "Ready_For_Collection";
    useEffect(() => {
        if (orderList.length > 0) {
            // eslint-disable-next-line 
            setFilteredOrders(orderList.filter(function (order) {
                if (order.order_status) {
                    if (order.order_status.trim() !== OrderStatus.STARTED) {
                        if (order.order_status.trim() !== OrderStatus.REJECTED) {
                            return order;
                        }
                    }
                }
            }));
        } else {
            setFilteredOrders([]);
        }
    }, [orderList]);
    function Row({ index, style }: IListItemRow) {
        return (
            <div style={style} key={index} data-component-name="OrderHistory">
                <OrderListItem order={filteredOrders[index]}
                    onClickItem={openOrderDialog} columns={columns} showCheckBox={showCheckBox} />
            </div>
        );
    }

    return filteredOrders.length > 0 ? <div className={Styles.listWrapper}>
        <List height={heightOverride ?? windowHeight}
            itemCount={filteredOrders.length}
            className={"ORDER_HISTORY_LIST"}
            itemSize={80}
            width={"100%"}
            style={{
                paddingBottom: "3.5rem",
                overflow: "auto",
            }}
        >
            {Row}
        </List>
    </div> : <NoSearchResult {...emptyMessageObject} />;
}

/**calculates the list height */
function calculateListHeight() {
    const windowheight = window.innerHeight - 125;
    return windowheight;
}
